/**
 * Contrato zod de la solapa "Completadas" de Despacho.
 *
 * Cada item es una fila de `traza_job` con `tipo='egreso'` y `status='success'`,
 * joined con users y gln. El backend extrae los `codigosTransaccion` del
 * `result_payload` para que el front no tenga que parsear el JSON crudo.
 */

import { z } from 'zod';
import { CumplirTareaInfoSchema, AnulacionInfoSchema } from './comprobantes';
import { ESTADOS_TRAZA_JOB } from '@/domain/types';

export const TrazaCompletadaSchema = z.object({
  id: z.number(),
  tipoComprobante: z.string().nullable(),
  /** Prefijo de la referencia (RFA/RES/…/DES) — se muestra en el chip. */
  sigla: z.string(),
  /** Clasificación legible: "Salida" | "Destrucción". */
  tipoLabel: z.string(),
  /** Movimiento por prefijo de referencia — para el color del chip. */
  movimiento: z.enum(['salida', 'destruccion']).optional(),
  referencia: z.string(),
  numeroRemito: z.string().nullable(),
  jobId: z.number(),
  /** 'success', o 'anulada' si después se canceló el egreso. */
  status: z.enum(ESTADOS_TRAZA_JOB).optional(),
  totalItems: z.number().nullable(),
  doneItems: z.number().nullable(),
  finishedAt: z.string().nullable(),
  createdAt: z.string().nullable(),
  usuario: z.object({
    id: z.number(),
    username: z.string(),
    nombre: z.string(),
  }),
  gln: z.object({
    id: z.number(),
    nombre: z.string(),
    gln: z.string(),
  }),
  codigosTransaccion: z.array(z.string()),
  /** ID de la tarea en ACSIS — para pedir el log de cumplir-tarea. */
  erpId: z.string().nullable().optional(),
  /** Cierre de tarea en el ERP: estado + fecha. */
  cumplirTarea: CumplirTareaInfoSchema.optional(),
  /** Anulación de la traza (2 pasos). null si ese paso no se hizo. */
  egresoAnulado: AnulacionInfoSchema.nullable().optional(),
  remitoAnulado: AnulacionInfoSchema.nullable().optional(),
});

export const GetCompletadasResponse = z.array(TrazaCompletadaSchema);
export type TrazaCompletada = z.infer<typeof TrazaCompletadaSchema>;
